var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71924 0H0.605658C0.277603 0 0 0.26503 0 0.605658V4.73185C0 5.05991 0.26503 5.33751 0.605658 5.33751H4.73185C5.05991 5.33751 5.33751 5.07248 5.33751 4.73185V0.605658C5.32493 0.26503 5.04731 0 4.71926 0H4.71924Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3833 0H7.26972C6.94167 0 6.66406 0.26503 6.66406 0.605658V4.73185C6.66406 5.05991 6.92909 5.33751 7.26972 5.33751H11.3959C11.724 5.33751 12.0016 5.07248 12.0016 4.73185V0.605658C11.989 0.26503 11.7239 0 11.3833 0Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71924 6.66309H0.605658C0.277603 6.66309 0 6.92812 0 7.26874V11.3949C0 11.723 0.26503 12.0006 0.605658 12.0006H4.73185C5.05991 12.0006 5.33751 11.7356 5.33751 11.3949V7.26874C5.32493 6.94069 5.04731 6.66309 4.71926 6.66309H4.71924Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3833 6.66309H7.26972C6.94167 6.66309 6.66406 6.92812 6.66406 7.26874V11.3949C6.66406 11.723 6.92909 12.0006 7.26972 12.0006H11.3959C11.724 12.0006 12.0016 11.7356 12.0016 11.3949V7.26874C11.989 6.94069 11.7239 6.66309 11.3833 6.66309Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.75850f7e46de1221b8e45f44e1606aef.svg";
export { ForwardRef as ReactComponent };